/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import _ from 'lodash';

/**
 * Convert object to array.
 *
 * On endurance the dashboardCategories are not parsed as arrays
 *
 * correct result:
 [
 {
    "label": "dashboard.category.national-procedures",
    "procedureIds": [
      "NATPAT",
      "EPVL"
    ]
  },
 {
    "label": "dashboard.category.international-procedures",
    "procedureIds": [
      "PCTRO101"
    ]
  }
 ]
 *
 * endurance result:
 {
  "1": {
    "procedureIds": {
      "1": "NATPAT",
      "2": "EPVL"
    },
    "label": "dashboard.category.national-procedures"
  },
  "2": {
    "procedureIds": {
      "1": "PCTRO101"
    },
    "label": "dashboard.category.international-procedures"
  }
 }
 */
export const convertCategoriesToArray = (categories) => {
  if (_.isArray(categories)) return categories;
  return convertObjectToArray(categories);
};

const convertObjectToArray = (object) => {
  if (!_.isObject(object)) throw new Error('Categories are not array or object');

  return _.keys(object)
    .sort()
    .map((key) => {
      const element = object[key];

      if (_.isString(element)) return element;

      if (_.has(element, 'label')) {
        return {
          label: element.label,
          procedureIds: convertObjectToArray(element.procedureIds),
        };
      }

      throw new Error('Unkown element');
    });
};
